// FormikCheckBox.js

import React, { useContext } from "react";
import { Typography } from "@mui/material";
import { ErrorMessage, FastField, Field } from "formik";
import TextError from "../TextError";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import useFormikCheckBox from "./useFormikCheckBox";

const FormikCheckBox = () => {
  const field = useContext(FormikControlContext);
  const { label, name, readOnly, validation } = field;

  const { handleChange, handleBlur } = useFormikCheckBox();

  const CheckBoxField = readOnly === undefined ? Field : FastField;

  return (
    <div>
      <Typography>
        {label}
        {validation?.required && <span>*</span>}
        <CheckBoxField
          className="mx-3"
          type="checkbox"
          name={name}
          onChange={handleChange}
          onBlur={handleBlur}
          id={name}
          required={validation?.required ?? false}
        />
        <span className="checkmark"></span>
      </Typography>

      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default FormikCheckBox;
